import React, { useEffect, useState } from "react";
import { Button, Input, Col, Form, Row, message, Switch, Card, Spin } from "antd";
import { useNavigate } from 'react-router-dom';
import { storage } from "../utils/storage";
import { IVersionData } from "../types/appversion";
import { useGetAppVersion, useUpdateAppVersion } from "../services/appversion.service";
import IResponse from "../types/response";
import { useAuth } from "../context/AuthContext";
const AppVersion: React.FC = () => {
    const [androidForm] = Form.useForm();
    const [iosForm] = Form.useForm();
    const navigate = useNavigate();

    const [androidData, setAndroidData] = useState<IVersionData | null>(null);
    const [iosData, setIosData] = useState<IVersionData | null>(null);
    const { hasPermission, permissionsLoaded, loadPermissions } = useAuth();

    useEffect(() => {
            loadPermissions();
    }, [permissionsLoaded]);

    const AppversionEdit = hasPermission("APP_VERSION", "UPDATE");

    useEffect(() => {
        let token = storage.getToken() ?? "";
        if (!token) {
            navigate("/");
            return;
        }
        fetchAppVersion();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    const fetchAppVersion = async () => {
        getAppVersioMutation.mutate({});
    };

    const getAppVersioMutation = useGetAppVersion({
        onSuccess: (response: IResponse) => {
            if (response && response.data) {
                setAndroidData(response.data.android);
                setIosData(response.data.ios);
            } else {
                message.error("Unexpected response format");
            }
        },
        onError: (error: any) => {
            message.error(error.message);
        },
    });

    const updateAppVersion = useUpdateAppVersion({
        onSuccess: (response: any) => {
            if (response.statusCode === 200) {
                message.success(response.statusMessage);
            } else {
                message.error(response.statusMessage);
            }
        },
        onError: (error) => {
            message.error(error.message);
        }
    });

    const onFinishAndroid = (values: IVersionData) => {
        const data = {
            ...values,
            platform: androidData?.platForm,
        }
        updateAppVersion.mutate(data);
    };

    const onFinishIos = (values: IVersionData) => {
        const data = {
            ...values,
            platform: iosData?.platForm,
        }
        updateAppVersion.mutate(data);
    };

    // If androidData or iosData is null, render loading spinner or default placeholder
    if (!androidData || !iosData) {
        return (
            <>
                <div className="flex justify-between align-middle pb-5">
                    <h2 className="text-2xl font-semibold text-black text-center">App Version Management</h2>
                </div>
                <div className="flex justify-center items-center w-full h-full">
                    <Spin />
                </div>
            </>
        );
    }

    return (
        <>
            <div className="flex justify-between align-middle pb-5">
                <h2 className="text-2xl font-semibold text-black text-center">App Version Management</h2>
            </div>
            <div className="flex justify-between items-center">
                <div style={{ width: "100%", maxWidth: "100%" }}>
                    <Row gutter={[32, 16]} justify="center">
                        {/* Android Card */}
                        <Col span={10}>
                            <Card
                                title="Android Version"
                                bordered
                                style={{
                                    borderRadius: "5px",
                                    border: "1px solid rgb(145 140 140)",
                                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <Form
                                    form={androidForm}
                                    layout="vertical"
                                    onFinish={onFinishAndroid}
                                    initialValues={androidData as IVersionData}
                                >
                                    <Form.Item label="Version Code" name="versionCode">
                                        <Input type="number" />
                                    </Form.Item>
                                    <Form.Item label="Version Name" name="versionName">
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Message" name="message">
                                        <Input.TextArea />
                                    </Form.Item>
                                    <Form.Item label="Force Update" name="isForceUpdate" valuePropName="checked">
                                        <Switch />
                                    </Form.Item>
                                       {AppversionEdit && (
                                    <Button
                                        htmlType="submit"
                                        className="bg-black text-white h-10 hover:!border-black hover:!bg-transparent hover:!text-black hover:transition hover:duration-500 hover:ease-in-out"
                                    >
                                        Save
                                    </Button>)}
                                </Form>
                            </Card>
                        </Col>

                        {/* iOS Card */}
                        <Col span={10}>
                            <Card
                                title="iOS Version"
                                bordered
                                style={{
                                    borderRadius: "5px",
                                    border: "1px solid rgb(145 140 140)",
                                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <Form
                                    form={iosForm}
                                    layout="vertical"
                                    onFinish={onFinishIos}
                                    initialValues={iosData as IVersionData}
                                >
                                    <Form.Item label="Version Code" name="versionCode">
                                        <Input type="number" />
                                    </Form.Item>
                                    <Form.Item label="Version Name" name="versionName">
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Message" name="message">
                                        <Input.TextArea />
                                    </Form.Item>
                                    <Form.Item label="Force Update" name="isForceUpdate" valuePropName="checked">
                                        <Switch />
                                    </Form.Item>
                                    {AppversionEdit && (
                                    <Button
                                        htmlType="submit"
                                        className="bg-black text-white h-10 hover:!border-black hover:!bg-transparent hover:!text-black hover:transition hover:duration-500 hover:ease-in-out"
                                    >
                                        Save
                                    </Button> )}
                                </Form>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default AppVersion;
